import axios from "axios";
import("dropzone").then((module) => {
    let Dropzone = module.default;
    let doc = $(document);

    doc.ready(function () {
        let fileInput = $("#files_form");
        if (fileInput.length > 0) {
            let myDropzone = new Dropzone("#files_form", {
                headers: {
                    "X-CSRF-TOKEN": $('[name="_token"]').val(), // Replace with a function to get the CSRF token
                },
                parallelUploads: 10,
                paramName: "files", // Change the parameter name to "files"
                clickable: true, // Disable click functionality
                previewsContainer: ".dropzone-preview-container", // Specify where to display previews
                uploadMultiple: true, // Upload multiple files simultaneously
                previewTemplate: `
            <div class="dropzone-preview">
                <div class="dropzone-file">
                    <div class="dropzone-filename" data-dz-name></div>
                    <div class="dropzone-file-end">
                        <div class="dropzone-filesize" data-dz-size></div>
                        <div class="dropzone-remove-preview" data-dz-remove>&times;</div>
                    </div>
                </div>
                <div class="dropzone-error-message"></div>
            </div>
            `, // Specify the template used for file previews
                autoProcessQueue: false,
                init: function () {
                    // Event listener for the success event
                    this.on("successmultiple", function (file, response) {
                        $(".modal_confirm").show();
                        $(".modal_loader").hide();
                        $(".file_container").append(response);
                        $("#files_placeholder").hide();
                        myDropzone.removeAllFiles();
                        let modalId = $(
                            "[data-modal-close-target-indirect]"
                        ).attr("data-modal-close-target-indirect");
                        $(".dropzone-error-messages").html("");
                        $("#" + modalId).hide(100);
                    });
                    //Error handling msg
                    this.on("error", function (file, response) {
                        console.log("error", response);
                        console.log("errorMessage", response.errors);
                        let errorIndexes = Object.keys(response.errors).map(
                            function (key) {
                                return key.split(".").pop();
                            }
                        );
                        console.log("errorIndexes", errorIndexes);
                        $(".dropzone-error-messages").html(
                            "Bestanden niet toegevoegd. Zie foutmeldingen hierboven."
                        );

                        errorIndexes.forEach(function (index) {
                            let errorContainer = $(
                                ".dropzone-error-message"
                            ).eq(index);
                            if (errorContainer) {
                                errorContainer.html(
                                    response.errors["files." + index].join(
                                        "<br>"
                                    )
                                );
                            }
                        });

                        $(".modal_confirm").show();
                        $(".modal_loader").hide();
                        $(".dropzone-error-messages").html(
                            "Bestanden niet toegevoegd. Zie foutmeldingen hierboven."
                        );
                    });
                },
            });

            $("#upload_files").on("click", function () {
                $(".dropzone-error-messages").html("");
                if (myDropzone.getQueuedFiles().length <= 0) {
                    return;
                }
                myDropzone.processQueue();
                $(".modal_confirm").hide();
                $(".modal_loader").show();
            });

            $("#cancel_upload_files").on("click", function () {
                $(".dropzone-error-messages").html("");
                myDropzone.removeAllFiles();
                let modalId = $(this).attr("data-modal-close-target-indirect");
                $("#" + modalId).hide(100);
                $(".modal_confirm").show();
                $(".modal_loader").hide();
            });
        }

        $(document).on("click", ".delete_file_btn", function () {
            let deleteBtn = $(this);

            showPopup(
                "Weet je het zeker?",
                "Weet je zeker dat je dit bestand wilt verwijderen?",
                "Verwijderen",
                "Annuleren",
                function () {
                    let fileId = deleteBtn.attr("data-file-id");
                    let customerSlug = deleteBtn.attr("data-customer-slug");
                    axios({
                        method: "delete",
                        url: "/customers/" + customerSlug + "/files/" + fileId,
                    })
                        .then(function () {
                            deleteBtn.closest(".file_item").remove();
                            if ($(".file_item").length <= 0) {
                                $("#files_placeholder").show();
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            );
        });
    });
});
